(() => {
  const STATUS_ICONS = {
    instock: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/auf_lager.svg?v=1774522602",
    backorder: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/bestellware.svg?v=1774522602",
    soldout: "https://cdn.shopify.com/s/files/1/0528/6831/7368/files/nicht_verfuegbar.svg?v=1774522602"
  };

  function getProductForm(root) {
    const component = root.closest('[data-js-product-component]');

    if (component) {
      return component.querySelector('form[data-type="add-to-cart-form"]');
    }

    return root.closest('form[action*="/cart/add"]');
  }

  function getVariantIdFromForm(root) {
    const form = getProductForm(root);
    const idInput = form ? form.querySelector('input[name="id"]') : null;

    return idInput && idInput.value ? idInput.value : null;
  }

  function translatedText(root, key, values = {}) {
    let text = root.dataset[key] || "";

    for (const [token, value] of Object.entries(values)) {
      text = text.split(token).join(String(value));
    }

    return text;
  }

  function setState(root, state, message) {
    const labelEl = root.querySelector(".delivery-info__label");
    const iconEl = root.querySelector(".delivery-info__icon");
    if (!labelEl) return;

    if (state === "is-instock" && iconEl) {
      iconEl.src = STATUS_ICONS.instock;
    }

    if (state === "is-backorder" && iconEl) {
      iconEl.src = STATUS_ICONS.backorder;
    }

    if (state === "is-soldout" && iconEl) {
      iconEl.src = STATUS_ICONS.soldout;
    }

    labelEl.textContent = message;
  }

  function render(root, variants, leadtime, variantId) {
    const v = variants[String(variantId)];
    if (!v) return;

    const tracked = v.inventory_management === "shopify";
    const qty = Number(v.qty) || 0;
    const available = !!v.available;
    const soldOutText = translatedText(root, "textSoldOut");

    if (root.dataset.preorder === "true") {
      if (available) {
        const preorderDate = (root.dataset.preorderDate || "").trim();
        const message = preorderDate
          ? translatedText(root, "textPreorder", { __SWG_DATE__: preorderDate })
          : translatedText(root, "textPreorderOnRequest");

        setState(root, "is-backorder", message);
      } else {
        setState(root, "is-soldout", soldOutText);
      }
      return;
    }

    const backorderText = leadtime
      ? translatedText(root, "textBackorder", { __SWG_LEADTIME__: leadtime })
      : translatedText(root, "textBackorderOnRequest");

    if (!tracked) {
      if (available) {
        setState(root, "is-backorder", backorderText);
      } else {
        setState(root, "is-soldout", soldOutText);
      }
      return;
    }

    if (qty > 0) {
      const message = qty < 5
        ? translatedText(root, "textLowStock", { __SWG_QUANTITY__: qty })
        : translatedText(root, "textInStock");

      setState(root, "is-instock", message);
      return;
    }

    if (available) {
      setState(root, "is-backorder", backorderText);
    } else {
      setState(root, "is-soldout", soldOutText);
    }
  }

  function initOne(root) {
    if (root.dataset.deliveryInfoInitialized === "true") return;
    root.dataset.deliveryInfoInitialized = "true";

    const variants = JSON.parse(root.dataset.variants || "{}");
    const leadtime = (root.dataset.leadtime || "").trim();
    const initialVariant = root.dataset.initialVariant || null;

    const current = getVariantIdFromForm(root) || initialVariant;
    if (current) render(root, variants, leadtime, current);

    const form = getProductForm(root);
    if (!form) return;

    form.addEventListener("change", () => {
      const id = getVariantIdFromForm(root);
      if (id) render(root, variants, leadtime, id);
    });

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          render(root, variants, leadtime, last);
        }
      }, 300);
    }
  }

  function initAll() {
    document.querySelectorAll(".delivery-info").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
